import { Modal, Table } from 'react-bootstrap'

import { BoxArrowUpRight } from 'react-bootstrap-icons'
import { Link } from 'react-router-dom'
import { CustomButton } from '../../../components/CustomButton'

export function ModalChildren({ isOpen, onClose, childrenData }) {
  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      centered
      dialogClassName="custom-modalzpl"
    >
      <Modal.Header closeButton>
        <Modal.Title>Produtos Filhos</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Table
          striped
          bordered
          hover
        >
          <thead>
            <tr>
              <th>Cód. Produto</th>
              <th>SKU</th>
              <th>Descrição</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {childrenData.map((child) => (
              <tr>
                <td>{child?.codproduto}</td>
                <td>{child?.sku}</td>
                <td>{child?.descricao}</td>
                <td>
                  <Link
                    target="_blank"
                    to={`/produtos/${child.codproduto}`}
                  >
                    <CustomButton title="Editar">
                      <BoxArrowUpRight />
                    </CustomButton>
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Modal.Body>
    </Modal>
  )
}
